import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

export const firebaseConfig = {
  apiKey: 'AIzaSyBaFu046hRNS-tGm-e0dsh3OvAQRBoDtWs',
  authDomain: 'nmzlakeland-a8568.firebaseapp.com',
  projectId: 'nmzlakeland-a8568',
  storageBucket: 'nmzlakeland-a8568.appspot.com',
  messagingSenderId: '187907537985',
  appId: '1:187907537985:web:4d0c0c80db074e216ddac0',
  measurementId: 'G-5FHNG08N1M',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
